export default __webpack_public_path__ + "static/media/0b.2091f5a1.png";